import { useEffect, useState, useCallback } from "react";
import { Modal } from "react-responsive-modal";
import 'react-responsive-modal/styles.css';
import { palabras } from "./utils/palabras";
import { dicc } from "./utils/dicc";
import { successGifs, failGifs } from "./utils/list";
import Keyboard from "./components/Keyboard";
// import AdSense from "./components/AdSense"; // Comentado - no se usa actualmente
import toast, { Toaster } from 'react-hot-toast';
// import { useNavigate } from "react-router-dom"; // Comentado - no se usa actualmente

export default function App() {  // <-- Esta línea debe estar aquí, al nivel superior
  const [successKeys, setSuccessKeys] = useState([]);
  const [misplacedKeys, setMisplacedKeys] = useState([]);
  const [failedKeys, setFailedKeys] = useState([]);
  const [secretWordIndex, setSecretWordIndex] = useState(0);
  const [secretWord, setSecretWord] = useState("");
  const [word, setWord] = useState("");
  const [tries, setTries] = useState(["", "", "", "", "", ""]);
  const [tryNumber, setTryNumber] = useState(0);
  const [update, setUpdate] = useState(false);
  const [status, setStatus] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [juego, setJuego] = useState("Juego");

  // Funciones comentadas - no se usan actualmente
  // const navigate = useNavigate();
  // function goToPreviousScreen(button) {
  //   if (button === 1) {
  //     navigate(-1); // Navegar a la página anterior
  //   }
  // }
  
  // function onBackButtonClick() {
  //   document.addEventListener(
  //     "backbutton",
  //     function (e) {
  //       navigator.notification.confirm(
  //         "Are you sure you want to leave the screen?",
  //         goToPreviousScreen,
  //         "Warning",
  //         "Yes, Cancel"
  //       ); // you can change the button names in the place of Yes, Cancel.
  //     },
  //     false
  //   );
  // }
  
  // if ($actions.CheckDialogsPlugin()) {
  //   onBackButtonClick();
  // }

  const updateKeyboard = useCallback(() => {
    const lastTry = tries[tries.filter(t => t !== "").length - 1];
    if (!lastTry) return;
    let newSuccessKeys = []
    let newMisplacedKeys = []
    let newFailedKeys = []
    const chars = [0, 1, 2, 3, 4]
    chars.forEach(i => {
      const char = lastTry.at(i);
      if (char && secretWord) {
        if (char.toLowerCase() === secretWord.at(i).toLowerCase()) {
          newSuccessKeys.push(char)
        } else if (secretWord.toLowerCase().indexOf(char.toLowerCase()) === -1) {
          newFailedKeys.push(char)
        } else {
          newMisplacedKeys.push(char)
        }
      }
    })
    setSuccessKeys(prev => [...prev, ...newSuccessKeys])
    setMisplacedKeys(prev => [...prev, ...newMisplacedKeys])
    setFailedKeys(prev => [...prev, ...newFailedKeys])
  }, [tries, secretWord]);

  const sendWord = useCallback(() => {
    if (!dicc.includes(word.toLowerCase())) {
      return toast('Esa palabra no existe, prueba con otra.');
    }
    
    const currentTryNumber = tryNumber;
    const newTries = [...tries];
    newTries[currentTryNumber] = word;
    
    if (word.toLowerCase() === secretWord.toLowerCase()) {
      setStatus("success")
      setModalOpen(true)
      setTries(newTries);
    } else if (currentTryNumber === 5) {
      setStatus("fail")
      setModalOpen(true)
      setTries(newTries);
    } else {
      setTries(newTries);
    }
    
    setTryNumber(prev => prev + 1);
    setWord("");
    updateKeyboard();
  }, [word, tries, tryNumber, secretWord, updateKeyboard]);

  const reset = useCallback(() => {
    setTryNumber(0);
    setTries(["", "", "", "", "", ""]);
    setWord("");
    setUpdate(prev => !prev)
    setModalOpen(false)
    setStatus("")
    setSuccessKeys([])
    setMisplacedKeys([])
    setFailedKeys([])
  }, []);

  const getGifUrl = status => {
    let url = "/gifs/";
    if (status === "success") {
      const index = Math.floor(Math.random() * successGifs.length)
      url += successGifs[index]
    } else {
      const index = Math.floor(Math.random() * failGifs.length)
      url += failGifs[index]
    }
    return url
  }

  useEffect(() => {
    const index = Math.floor(Math.random() * palabras.length);
    setSecretWordIndex(index);
  }, [update]);

  useEffect(() => {
    const newSecretWord = palabras[secretWordIndex]
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
    setSecretWord(newSecretWord);
  }, [secretWordIndex]);

  // Event listener para teclado físico
  useEffect(() => {
    const handleKeyPress = (event) => {
      // Solo procesar si no hay modal abierto
      if (modalOpen) return;
      
      const key = event.key.toLowerCase();
      
      // Tecla Enter para enviar palabra
      if (key === 'enter') {
        event.preventDefault();
        if (word.length === 5) {
          sendWord();
        }
        return;
      }
      
      // Tecla Backspace para borrar
      if (key === 'backspace') {
        event.preventDefault();
        setWord(word.substring(0, word.length - 1));
        return;
      }
      
      // Tecla Escape para cerrar modal o reset
      if (key === 'escape') {
        event.preventDefault();
        if (modalOpen) {
          setModalOpen(false);
        } else if (status !== "") {
          reset();
        }
        return;
      }
      
      // Solo procesar letras (a-z, ñ)
      if (key.length === 1 && /[a-zñ]/.test(key)) {
        event.preventDefault();
        // Solo añadir si la palabra no tiene 5 letras
        if (word.length < 5) {
          setWord(word + key);
        }
      }
    };

    // Añadir event listener
    document.addEventListener('keydown', handleKeyPress);
    
    // Cleanup
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [word, modalOpen, status, sendWord, reset]);

  const type = key => {
    if (key === "send") {
      return sendWord();
    }
    if (key === "back") {
      return setWord(word.substring(0, word.length - 1))
    }
    return setWord(word + key)
  }

  return (
    <div className="flex flex-col justify-between items-center min-h-screen">
      <div className="flex flex-col items-center p-2 sm:p-3 md:p-2 lg:p-3 xl:p-4 2xl:p-6 gap-2 sm:gap-3 md:gap-2 lg:gap-3 xl:gap-4 2xl:gap-6">
        <div className="flex items-center justify-center gap-2 sm:gap-4 md:gap-2 lg:gap-4 xl:gap-6 2xl:gap-8">
          <picture className="w-8 h-8 sm:w-10 sm:h-10 md:w-8 md:h-8 lg:w-10 lg:h-10 xl:w-12 xl:h-12 2xl:w-14 2xl:h-14 flex justify-center items-center">
            <img src="/piterpal_64.png" alt="logo" />
          </picture>
          <div className="flex flex-col items-baseline">
            <h1 className="text-center font-semibold text-lg sm:text-xl md:text-lg lg:text-xl xl:text-2xl 2xl:text-3xl">PITER-PAL</h1>
            <h2 className="text-xs sm:text-xs md:text-xs lg:text-sm xl:text-sm 2xl:text-base font-semibold italic text-orange-500">A que no juegas solo una</h2>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center gap-0.5 sm:gap-1 md:gap-0.5 lg:gap-1 xl:gap-1.5 2xl:gap-2 max-w-2xl">
          {tries.map((tr, i) => i !== tryNumber ? (
            <div key={i} className="w-full grid grid-cols-5 gap-0.5 sm:gap-1 md:gap-0.5 lg:gap-1 xl:gap-1.5 2xl:gap-2">
              {[0, 1, 2, 3, 4].map((j) => (
                <div
                  key={j}
                  className={`border rounded-lg w-10 xs:w-12 sm:w-14 sm-plus:w-16 md:w-12 md-plus:w-14 lg:w-12 lg-plus:w-16 xl:w-14 xl-plus:w-18 2xl:w-16 h-10 xs:h-12 sm:h-14 sm-plus:h-16 md:h-12 md-plus:h-14 lg:h-12 lg-plus:h-16 xl:h-14 xl-plus:h-18 2xl:h-16 flex justify-center items-center uppercase font-bold text-2xl xs:text-2xl sm:text-xl sm-plus:text-xl md:text-lg md-plus:text-xl lg:text-lg lg-plus:text-2xl xl:text-xl xl-plus:text-3xl 2xl:text-2xl 
                ${typeof tr.at(j) === "undefined"
                      ? "bg-white"
                      : tr.at(j).toLowerCase() === secretWord.at(j).toLowerCase()
                        ? "bg-green-400 text-white border-green-400"
                        : secretWord.toLowerCase().indexOf(tr.at(j).toLowerCase()) === -1
                          ? "bg-gray-500 border-gray-500 text-white"
                          : "bg-yellow-400 border-yellow-400"
                    }
                    ${i > tryNumber && "opacity-40"
                    }
                    `}
                >
                  {tr.at(j)}
                </div>
              ))}
            </div>
          ) : (
            <div key={i} className="w-full grid grid-cols-5 gap-0.5 sm:gap-1 md:gap-0.5 lg:gap-1 xl:gap-1.5 2xl:gap-2">
              {[0, 1, 2, 3, 4].map((j) => (
                <div
                  key={j}
                  className={`border rounded-lg w-10 xs:w-12 sm:w-14 sm-plus:w-16 md:w-12 md-plus:w-14 lg:w-12 lg-plus:w-16 xl:w-14 xl-plus:w-18 2xl:w-16 h-10 xs:h-12 sm:h-14 sm-plus:h-16 md:h-12 md-plus:h-14 lg:h-12 lg-plus:h-16 xl:h-14 xl-plus:h-18 2xl:h-16 flex justify-center items-center uppercase bg-white font-bold text-2xl xs:text-2xl sm:text-xl sm-plus:text-xl md:text-lg md-plus:text-xl lg:text-lg lg-plus:text-2xl xl:text-xl xl-plus:text-3xl 2xl:text-2xl`}
                >
                  {word.at(j)}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
      <Keyboard type={type} reset={reset} status={status} tries={tries} successKeys={successKeys} misplacedKeys={misplacedKeys} failedKeys={failedKeys} />
      {/* <AdSense /> */}
      <span className="my-4 text-center italic text-sm text-slate-500"><span onDoubleClick={() => setJuego(secretWord)}>{juego}</span> desarrollado por <a href="https://gorkavillar.dev" target="_blank noreferrer" className="underline">Gorka Villar</a></span>
      <Modal
        showCloseIcon={false}
        open={modalOpen}
        center
        closeOnOverlayClick={true}
        onClose={() => setModalOpen(false)}>
        {status === "success" && <div className="flex flex-col justify-center items-center gap-4">
          <img src={getGifUrl("success")} alt="¡Enhorabuena!" />
          <h1 className="text-lg font-semibold text-green-600 text-center">¡Enhorabuena! ¿Quieres volver a intentarlo?</h1>
          <div className="flex gap-4">
            <button className="border border-red-500 text-red-500 rounded-lg py-1 px-2" onClick={() => setModalOpen(false)}>No por ahora...</button>
            <button className="bg-green-500 text-white border border-green-500 rounded-lg py-1 px-2" onClick={reset}>¡Pues claro!</button>
          </div>
          {/* <AdSense /> */}
        </div>}
        {status === "fail" && <div className="flex flex-col justify-center items-center gap-4">
          <img src={getGifUrl("fail")} alt="¡Fallaste!" />
          <h1 className="text-lg font-semibold text-red-600 text-center">¡Noooo!¡Fallaste! ¿Quieres volver a intentarlo?</h1>
          <h1 className="text-lg text-slate-600 text-center">La respuesta correcta era... <span className="uppercase font-bold">{secretWord}</span></h1>
          <div className="flex gap-4">
            <button className="border border-red-500 text-red-500 rounded-lg py-1 px-2" onClick={() => setModalOpen(false)}>No por ahora...</button>
            <button className="bg-green-500 text-white border border-green-500 rounded-lg py-1 px-2" onClick={reset}>¡Pues claro!</button>
          </div>
          {/* <AdSense /> */}
        </div>}
      </Modal>
      <Toaster position="top-center" />
    </div>
  );
}
